import { FC, useCallback } from "react";
import Stack from "@mui/material/Stack";
import { useFlag } from "@unleash/proxy-client-react";
import { Typography } from "@mui/material";
import {
  CommitmentsAgGrid,
  CommitmentsToolbar,
} from "@/components/pages/commtiments/common/components/CommitmentsAgGrid";
import { reservationsRecommendationsGridColumnsDefs } from "@/components/pages/commtiments/reservations/components/content/recomendations/data-grid/reservationsRecommendationsGridColumnsDefs";
import { useAppSelector } from "@/store/hooks";
import { reservationsRecommendationsFilteredDataSelector } from "@/store/commitments/selectors/recommendations/reservations/reservationsRecommendationsFilteredDataSelector";
import { commitmentsDetailsDrawerTargetTypeSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerTargetTypeSelector";
import { ReservationCoverageDrawerRecommendationsGridToolbar } from "@/components/pages/commtiments/reservations/components/drawers/coverage-drawer/recommendations/ReservationCoverageDrawerRecommendationsGridToolbar";
import { reservationsRecommendationsLoadingSelector } from "@/store/commitments/selectors/recommendations/reservations/reservationsRecommendationsLoadingSelector";

export const ReservationCoverageDrawerRecommendationTab: FC = () => {
  const loader = useAppSelector(reservationsRecommendationsLoadingSelector);
  const enableReservationRecommendation = useFlag(
    "EnableReservationRecommendation",
  );

  const data = useAppSelector(reservationsRecommendationsFilteredDataSelector);

  const targetType = useAppSelector(commitmentsDetailsDrawerTargetTypeSelector);

  const toolbar: CommitmentsToolbar = useCallback(
    (props) => (
      <ReservationCoverageDrawerRecommendationsGridToolbar
        targetType={targetType}
        {...props}
      />
    ),
    [targetType],
  );

  if (!enableReservationRecommendation) {
    return null;
  }

  return (
    <Stack py={1.5} height="100%" p={1.5}>
      <CommitmentsAgGrid
        data={data ?? []}
        Toolbar={toolbar}
        columnDefs={reservationsRecommendationsGridColumnsDefs}
        localStorageUniqueKey="ReservationCoverageDrawerRecommendationsSection"
        overrideDefaultColDef={defaultColDef}
        loading={loader}
        noRowOverlayComponent={NoRowOverlayComponent}
        overrideWrapperStyles={overrideWrapperStyles}
      />
    </Stack>
  );
};
const defaultColDef = { filter: false };

const overrideWrapperStyles = {
  "& .ag-root-wrapper": {
    borderRadius: 2,
    border: 1,
    borderColor: "grey.300",
  },
};

const NoRowOverlayComponent = () => {
  return (
    <Stack alignItems="center" p={3}>
      <Typography
        variant="subtitle1"
        fontWeight="medium"
        color="text.secondary"
      >
        No Recommendations
      </Typography>
    </Stack>
  );
};
